export interface AdminMfaChallenge {
  mfaRequired: true;
  challengeId: string;
  challengeExpiresAt: string;
  enrollmentRequired?: true;
  otpAuthUri?: string;
}

export function readManualTotpKey(uri: string): string {
  try {
    const url = new URL(uri);
    const secret = url.searchParams.get('secret') ?? '';
    return url.protocol === 'otpauth:' && url.hostname === 'totp' && /^[A-Z2-7]{16,128}$/i.test(secret)
      ? secret
      : '';
  } catch {
    return '';
  }
}

export function parseAdminMfaChallenge(raw: Record<string, unknown>): AdminMfaChallenge | null {
  if (raw.mfaRequired !== true) return null;
  const challengeId = typeof raw.challengeId === 'string' ? raw.challengeId.trim() : '';
  const challengeExpiresAt = typeof raw.challengeExpiresAt === 'string' ? raw.challengeExpiresAt.trim() : '';
  if (!challengeId || !challengeExpiresAt || !Number.isFinite(Date.parse(challengeExpiresAt))) {
    throw new Error('Challenge MFA admin invalide.');
  }
  if (raw.enrollmentRequired === true) {
    const otpAuthUri = typeof raw.otpAuthUri === 'string' ? raw.otpAuthUri : '';
    if (!readManualTotpKey(otpAuthUri)) throw new Error('Configuration TOTP admin invalide.');
    return { mfaRequired: true, challengeId, challengeExpiresAt, enrollmentRequired: true, otpAuthUri };
  }
  return { mfaRequired: true, challengeId, challengeExpiresAt };
}
